export const suggestedCategories = [
  "Komposithegn",
  "Panelhegn",
  "Smedejernshegn",
  "Rionethegn",
  "Betonhegn",
  "Træbeklædt hegn",
  "Kompositlåge",
  "Panellåge",
  "Rionetlåge",
  "Smedejernslåge",
  "Træbeklædte låger",
  "Skydeporte",
  "Foldeporte",
  "Svingport / Dobbeltport",
  "Carport",
  "Skur / Udhus",
  "Facader",
  "Vinduespartier",
  "Erhverv & Privat",
  "Projekt / Nyhed",
  "Andet / Ikke afklaret"
];

export const albums = [
  {
    id: 1,
    albumNumber: "01",
    title: "Havedør og inspektionslem i hvid pudset mur",
    suggestedCategory: "Træbeklædte låger",
    description: "Udvendig havedør og inspektionslem i hvidpudset mur. Begge udført med kraftig galvaniseret stålramme og vandrette mørke profilbrædder.",
    date: "29. december 2025",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "IMG20251229122541.jpg",
        sitePath: "/_assets/img20251229122541.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251229122541.jpg",
        title: "Udvendig inspektionslem med stålramme og mørke profiler",
        description: "Udvendig lofts- eller inspektionslem monteret i hvidpudset gavl under tagudhæng."
      },
      {
        fileName: "IMG20251229122934.jpg",
        sitePath: "/_assets/img20251229122934.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251229122934.jpg",
        title: "Havedør med stålramme monteret mellem hvide mure",
        description: "Udendørs havedør i galvaniseret stålramme med mørkebrune vandrette profiler mellem to hvidpudsede mure."
      }
    ]
  },
  {
    id: 2,
    albumNumber: "02",
    title: "Dobbeltport med galvaniseret stålramme og sorte profiler",
    suggestedCategory: "Træbeklædte låger",
    description: "Tofløjet port med galvaniseret stålramme og sorte profilbrædder med træstruktur, monteret på flisebelægning mellem rød murstensvæg og sort træfacade.",
    date: "22. marts 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "IMG20260322162839.jpg",
        sitePath: "/_assets/img20260322162839.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20260322162839.jpg",
        title: "Dobbeltport mellem rød mursten og sort træbeklædning",
        description: "Galvaniseret stålramme med sorte profilbrædder og synlig træstruktur monteret på fliser."
      }
    ]
  },
  {
    id: 3,
    albumNumber: "03",
    title: "Havelåge med sikkerhedspigge mellem hvide mure",
    suggestedCategory: "Kompositlåge",
    description: "Havelåge i galvaniseret stål med mørkegrå kompositbrædder og sikkerhedspigge på overkanten, monteret mellem to hvidkalkede havemure.",
    date: "8. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "PXL_20260608_094742985.MP.jpg",
        sitePath: "/_assets/pxl-20260608-094742985-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260608-094742985-mp.jpg",
        title: "Mørk havelåge med pigge foroven i havemur",
        description: "Galvaniseret stålramme med mørkebrune kompositlameller og afslutning med sikkerhedspigge."
      }
    ]
  },
  {
    id: 4,
    albumNumber: "04",
    title: "Skurdør / udhusdør i galvaniseret stål og komposit",
    suggestedCategory: "Skur / Udhus",
    description: "Skurdør eller udhusdør i kraftig galvaniseret stålramme med mørkegrå træstrukturprofiler, integreret i sort træbeklædt facade.",
    date: "11. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "PXL_20260611_130115349.jpg",
        sitePath: "/_assets/pxl-20260611-130115349.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260611-130115349.jpg",
        title: "Skurdør med galvaniseret stålramme og kompositpaneler",
        description: "Dør i stålramme monteret plan i sort trævæg på flisebelægning."
      }
    ]
  },
  {
    id: 5,
    albumNumber: "05",
    title: "Havelåge mellem murede murstensstolper",
    suggestedCategory: "Kompositlåge",
    description: "Moderne havelåge med mørkebrune vandrette kompositbrædder og galvaniseret stålramme, monteret mellem to murede stolper.",
    date: "15. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "PXL_20260615_135924900.jpg",
        sitePath: "/_assets/pxl-20260615-135924900.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260615-135924900.jpg",
        title: "Havelåge med kompositbrædder mellem murstenssøjler",
        description: "Galvaniseret stålramme med mørke lameller indrammet af to klassiske murstenssøjler."
      }
    ]
  },
  {
    id: 6,
    albumNumber: "06",
    title: "Bred tofløjet erhvervs- / indkørselsport ved brosten",
    suggestedCategory: "Foldeporte",
    description: "Meget bred tofløjet port i galvaniseret stålkonstruktion med mørke komposit- eller træpaneler monteret for enden af brolagt køreareal foran erhvervsbygninger.",
    date: "19. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 6)",
    images: [
      {
        fileName: "PXL_20260619_125952937.MP.jpg",
        sitePath: "/_assets/pxl-20260619-125952937-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260619-125952937-mp.jpg",
        title: "Bred tofløjet port ved brostensbelægning",
        description: "Robust dobbeltport med stålramme og mørke vandrette fyldninger ved erhvervsbygning."
      }
    ]
  },
  {
    id: 7,
    albumNumber: "07",
    title: "Mørkegråt komposithegn med betonsokkel langs græsplæne",
    suggestedCategory: "Komposithegn",
    description: "Langt havehegn i mørkegrå kompositprofiler med træstruktur og lyse betonbundplader opstillet langs græsplæne mod grønt skovbryn.",
    date: "27. april 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 1)",
    images: [
      {
        fileName: "PXL_20260427_130837583.jpg",
        sitePath: "/_assets/pxl-20260427-130837583.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260427-130837583.jpg",
        title: "Komposithegn med betonbundplade langs have",
        description: "Mørkegråt komposithegn med lyse betonbundplader monteret langs en velplejet græsplæne."
      },
      {
        fileName: "PXL_20260427_130943932.jpg",
        sitePath: "/_assets/pxl-20260427-130943932.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260427-130943932.jpg",
        title: "Komposithegn med betonsokkel i solskin",
        description: "Nærbillede af kompositprofiler og betonsokkel langs haven under skyfri himmel."
      }
    ]
  },
  {
    id: 8,
    albumNumber: "08",
    title: "Mørkt komposithegn og matchende låge ved murstenshus",
    suggestedCategory: "Komposithegn",
    description: "Mørkt komposithegn med vandrette brædder opstillet på let skrånende grund med græsplæne, afsluttet med integreret havelåge ved en lys murstensvæg.",
    date: "26. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 1)",
    images: [
      {
        fileName: "PXL_20260626_134228707.jpg",
        sitePath: "/_assets/pxl-20260626-134228707.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-134228707.jpg",
        title: "Mørkt komposithegn langs plæne på skrånende grund",
        description: "Komposithegn med sorte stolper og vandrette brædder på græsplæne."
      },
      {
        fileName: "PXL_20260626_135051675.MP.jpg",
        sitePath: "/_assets/pxl-20260626-135051675-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-135051675-mp.jpg",
        title: "Kompositlåge og hegn ved lys murstensvæg og flisegang",
        description: "Matchende kompositlåge monteret ved siden af lys murstensvæg og flisegang."
      }
    ]
  },
  {
    id: 9,
    albumNumber: "09",
    title: "Sort komposithegn, trindelt forløb & låge ved villa (nr. 66)",
    suggestedCategory: "Komposithegn",
    description: "Komplet hegnsløsning ved villa nr. 66: komposithegn monteret op ad carport, trindelt hegn langs skrånende flisebelagt gangsti, samt integreret låge over granitsokkel.",
    date: "10. juli 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 1)",
    images: [
      {
        fileName: "PXL_20260710_142248728.jpg",
        sitePath: "/_assets/pxl-20260710-142248728.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142248728.jpg",
        title: "Sort komposithegn og låge langs have og carport",
        description: "Komposithegn med låge op ad carport ved skel mod have."
      },
      {
        fileName: "PXL_20260710_142439967.jpg",
        sitePath: "/_assets/pxl-20260710-142439967.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142439967.jpg",
        title: "Trindelt komposithegn langs skrånende sti ved villa",
        description: "Sort komposithegn monteret i niveauer langs skrånende flisegang ved murstenshus nr. 66."
      },
      {
        fileName: "PXL_20260710_142506610.jpg",
        sitePath: "/_assets/pxl-20260710-142506610.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142506610.jpg",
        title: "Kompositlåge i sort ramme over granitsokkel",
        description: "Mørkegråt komposithegn med indbygget låge monteret over lav granitkant mod have."
      }
    ]
  },
  {
    id: 10,
    albumNumber: "10",
    title: "Indhegnet køkkenhave med rionethegn & højbede",
    suggestedCategory: "Rionethegn",
    description: "Køkkenhave anlagt med tråd-/rionethegn omkring højbede med grøntsager, inklusive tilpasset trådgitterlåge og grusstier foran grøn havehæk.",
    date: "9. juli 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 2)",
    images: [
      {
        fileName: "PXL_20260709_112346689.jpg",
        sitePath: "/_assets/pxl-20260709-112346689.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112346689.jpg",
        title: "Køkkenhave med højbede og rionethegn",
        description: "Rustik indhegning af køkkenhave med rionethegn og træhøjbede."
      },
      {
        fileName: "PXL_20260709_112353116.jpg",
        sitePath: "/_assets/pxl-20260709-112353116.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112353116.jpg",
        title: "Gitterlåge som indgang til køkkenhave",
        description: "Trådnetlåge i stålramme foran grusstier og højbede."
      },
      {
        fileName: "PXL_20260709_112402346.jpg",
        sitePath: "/_assets/pxl-20260709-112402346.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112402346.jpg",
        title: "Oversigt over indhegnet haveområde med højbede",
        description: "Komplet overblik over haven omkranset af trådhegn og frodige hække."
      }
    ]
  },
  {
    id: 11,
    albumNumber: "11",
    title: "Haveanlæg med trådhegn, låge og komposithegn ved gult hus",
    suggestedCategory: "Panelhegn",
    description: "Have under anlæggelse med bar jord og galvaniseret tråd-/panelhegn med låge i forgrunden, samt mørkt komposithegn og nylagt fliseterrasse i baggrunden.",
    date: "13. april 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 2)",
    images: [
      {
        fileName: "PXL_20260413_100655471.jpg",
        sitePath: "/_assets/pxl-20260413-100655471.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260413-100655471.jpg",
        title: "Galvaniseret trådhegn og komposithegn ved parcelhus",
        description: "Galvaniseret hegn med låge opstillet ved haveanlæg foran gult murstenshus."
      }
    ]
  },
  {
    id: 12,
    albumNumber: "12",
    title: "Automatisk buet dobbeltport mellem hvide murstenssøjler",
    suggestedCategory: "Svingport / Dobbeltport",
    description: "Flot buet, dobbeltfløjet svingport i galvaniseret stål monteret mellem to hvidkalkede murstenssøjler med røde tegl. Udstyret med portautomatik ved grusbelagt indkørsel.",
    date: "5. juli 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 3)",
    images: [
      {
        fileName: "PXL_20260705_162316724.jpg",
        sitePath: "/_assets/pxl-20260705-162316724.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260705-162316724.jpg",
        title: "Automatisk dobbeltfløjet metalport ved indkørsel",
        description: "Buet galvaniseret dobbeltport med elektrisk portåbner ved indkørsel."
      },
      {
        fileName: "PXL_20260705_162325452.jpg",
        sitePath: "/_assets/pxl-20260705-162325452.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260705-162325452.jpg",
        title: "Svingport monteret mellem hvide søjler med tegltag",
        description: "Portautomatik og galvaniseret stålkonstruktion mellem to murede søjler."
      }
    ]
  },
  {
    id: 13,
    albumNumber: "13",
    title: "Sortlakeret smedejernslåge ved mørk træfacade & flisegang",
    suggestedCategory: "Smedejernslåge",
    description: "Sortlakeret metallåge med lodrette tremmer monteret mellem mørk træbeklædt facade og hæk/stolpe over en flisebelagt havesti.",
    date: "15. oktober 2025",
    batch: "WeTransfer 11. juli 2026 (Mappe 3)",
    images: [
      {
        fileName: "IMG20251015162706.jpg",
        sitePath: "/_assets/img20251015162706.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251015162706.jpg",
        title: "Sort tremmelåge monteret ved flisebelagt havesti",
        description: "Sortlakeret metallåge med lodrette tremmer foran havesti og hæk."
      },
      {
        fileName: "IMG20251015162947.jpg",
        sitePath: "/_assets/img20251015162947.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251015162947.jpg",
        title: "Sort havelåge ved sort træbeklædt bygning",
        description: "Metallåge monteret op ad bygningsfacade og firkantet stolpe over fliser."
      }
    ]
  },
  {
    id: 14,
    albumNumber: "14",
    title: "Sort komposithegn om hjørnegrund langs fortov og vej",
    suggestedCategory: "Komposithegn",
    description: "Langt, elegant sort komposithegn med galvaniserede stålstolper monteret omkring hjørnet af en villagrund mod fortov og asfalteret vej.",
    date: "20. april 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260420_113446037.jpg",
        sitePath: "/_assets/pxl-20260420-113446037.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260420-113446037.jpg",
        title: "Sort komposithegn om hjørnegrund langs fortov",
        description: "Hegn med vandrette sorte profiler og galvaniserede stolper i boligkvarter."
      }
    ]
  },
  {
    id: 15,
    albumNumber: "15",
    title: "Gråbrunt komposithegn med galvaniserede stålstolper",
    suggestedCategory: "Komposithegn",
    description: "Langt havehegn opført i varme, gråbrune kompositbrædder med træstruktur, monteret i galvaniserede H-stålstolper langs vej og jordvold.",
    date: "30. april – 3. juli 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260430_173443839.jpg",
        sitePath: "/_assets/pxl-20260430-173443839.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260430-173443839.jpg",
        title: "Gråbrunt komposithegn med galvaniserede stålstolper",
        description: "Vandrette kompositbrædder monteret i stålstolper mod blå himmel."
      },
      {
        fileName: "PXL_20260703_095205669.jpg",
        sitePath: "/_assets/pxl-20260703-095205669.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260703-095205669.jpg",
        title: "Langt brunt komposithegn langs vej",
        description: "Langt afskærmende komposithegn med stålstolper opført langs asfalteret vej."
      }
    ]
  },
  {
    id: 16,
    albumNumber: "16",
    title: "Mørkegråt komposithegn i indkørsel (med rød Corvette)",
    suggestedCategory: "Komposithegn",
    description: "Flot stemningsbillede med en rød Corvette parkeret på flisebelagt indkørsel foran et mørkegråt komposithegn med metalstolper.",
    date: "22. maj 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260522_165345604.MP.jpg",
        sitePath: "/_assets/pxl-20260522-165345604-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260522-165345604-mp.jpg",
        title: "Rød Corvette ved mørkegråt komposithegn",
        description: "Kromfælg og rød Corvette foran nyetableret komposithegn i indkørsel."
      }
    ]
  },
  {
    id: 17,
    albumNumber: "17",
    title: "Mørkegråt komposithegn langs flisegang og teknikskab",
    suggestedCategory: "Komposithegn",
    description: "Mørkegråt komposithegn med galvaniserede stålstolper monteret præcist langs flisebelagt gangsti foran et murstenshus.",
    date: "8. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260608_112249497.jpg",
        sitePath: "/_assets/pxl-20260608-112249497.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260608-112249497.jpg",
        title: "Mørkegråt komposithegn langs flisebelagt sti",
        description: "Hegn med stålstolper monteret ved flisebelægning foran murstensvilla."
      }
    ]
  },
  {
    id: 18,
    albumNumber: "18",
    title: "Komposithegn med to låger mellem to bygninger",
    suggestedCategory: "Kompositlåge",
    description: "Mørkegråt komposithegn med galvaniserede stålrammer og to integrerede havelåger, opstillet i passage mellem to bygninger.",
    date: "15. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260615_140042784.jpg",
        sitePath: "/_assets/pxl-20260615-140042784.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260615-140042784.jpg",
        title: "Komposithegn med to låger i stålramme",
        description: "Mørkegrå hegnsprofiler og to låger monteret mellem to murbygninger."
      }
    ]
  },
  {
    id: 19,
    albumNumber: "19",
    title: "Gråt komposithegn med havelåge på flisebelægning",
    suggestedCategory: "Komposithegn",
    description: "Udendørs hegn i grå kompositbrædder med træstruktur og galvaniserede stålstolper, udstyret med matchende havelåge på fliseterrasse.",
    date: "22. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 4)",
    images: [
      {
        fileName: "PXL_20260622_105620052.MP.jpg",
        sitePath: "/_assets/pxl-20260622-105620052-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260622-105620052-mp.jpg",
        title: "Gråt komposithegn med låge på flisebelægning",
        description: "Komposithegn og havelåge i galvaniserede stålprofiler på fliser."
      }
    ]
  },
  {
    id: 20,
    albumNumber: "20",
    title: "Galvaniseret panelhegn langs grusvej og parcelhushave",
    suggestedCategory: "Panelhegn",
    description: "Langt galvaniseret stålpanelhegn monteret langs en grusvej som solid og vedligeholdelsesfri afgrænsning af en stor græsplæne ved et parcelhus.",
    date: "23. december 2025",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "IMG20251223131731.jpg",
        sitePath: "/_assets/img20251223131731.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251223131731.jpg",
        title: "Galvaniseret panelhegn langs grusvej",
        description: "Panelhegn i varmgalvaniseret stål opsat langs grusvej foran parcelhushave."
      }
    ]
  },
  {
    id: 21,
    albumNumber: "21",
    title: "Galvaniseret gitterlåge med beskyttelsesplade ved cykelskur / depot",
    suggestedCategory: "Panellåge",
    description: "Aflukke med kraftig galvaniseret trådgitterlåge og stor rund dækplade/afskærmning monteret mellem to røde murstenssøjler foran depotrum eller cykelskur.",
    date: "24. december 2025",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "IMG20251224093853.jpg",
        sitePath: "/_assets/img20251224093853.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251224093853.jpg",
        title: "Galvaniseret gitterlåge foran depotrum",
        description: "Gitterlåge med cylinderlås og rund beskyttelsesplade mellem murstensstolper."
      }
    ]
  },
  {
    id: 22,
    albumNumber: "22",
    title: "Sort dobbelttrådspanelhegn i forhave med blodbøg",
    suggestedCategory: "Panelhegn",
    description: "Klassisk sort pulverlakeret dobbelttrådshegn i metal monteret langs en forhave med veltrimmet græsplæne foran et stort træ med røde blade og et gult parcelhus.",
    date: "8. maj 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "PXL_20260508_133014856.jpg",
        sitePath: "/_assets/pxl-20260508-133014856.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260508-133014856.jpg",
        title: "Sort panelhegn langs forhave med gult hus",
        description: "Sort dobbelttrådspanelhegn opstillet langs villavej og græsplæne."
      }
    ]
  },
  {
    id: 23,
    albumNumber: "23",
    title: "Sort panelhegn og gitterlåge ved murstenshus og terrasse",
    suggestedCategory: "Panellåge",
    description: "Sort panelhegn med tilhørende gitterlåge monteret ved rød murstensbygning, flisegang og terrasse med krukker og havemøbler.",
    date: "31. maj 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "PXL_20260531_083803960.jpg",
        sitePath: "/_assets/pxl-20260531-083803960.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260531-083803960.jpg",
        title: "Sort gitterlåge monteret ved rød murstensvæg",
        description: "Sort metallåge mellem hegnspanel og murstensvæg ved gårdsplads."
      },
      {
        fileName: "PXL_20260531_083822023.jpg",
        sitePath: "/_assets/pxl-20260531-083822023.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260531-083822023.jpg",
        title: "Sort panelhegn med låge ved terrasse og have",
        description: "Hegn og låge afgrænser haven og den flisebelagte terrasse."
      }
    ]
  },
  {
    id: 24,
    albumNumber: "24",
    title: "Galvaniseret dobbeltlåge / gitterport på grusindkørsel",
    suggestedCategory: "Panellåge",
    description: "Galvaniseret tofløjet trådnetlåge monteret over en bred grusbelagt indkørsel ved siden af hvid bygning og firmavarebil.",
    date: "26. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "PXL_20260626_182849918.MP.jpg",
        sitePath: "/_assets/pxl-20260626-182849918-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-182849918-mp.jpg",
        title: "Galvaniseret dobbeltlåge på grusindkørsel",
        description: "Tofløjet gitterport i galvaniseret stål monteret over indkørsel."
      }
    ]
  },
  {
    id: 25,
    albumNumber: "25",
    title: "Galvaniseret panelhegn omkring sandareal / legeplads",
    suggestedCategory: "Panelhegn",
    description: "Lavt galvaniseret panelhegn af stål opsat omkring et sandområde ved siden af en mørkegrå træbygning.",
    date: "27. juni 2026",
    batch: "WeTransfer 11. juli 2026 (Mappe 5)",
    images: [
      {
        fileName: "PXL_20260627_112148598.MP.jpg",
        sitePath: "/_assets/pxl-20260627-112148598-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260627-112148598-mp.jpg",
        title: "Galvaniseret panelhegn omkring sandkasse",
        description: "Lavt hegn af galvaniserede trådpaneler omkring sandområde ved skur."
      }
    ]
  },
  {
    id: 26,
    albumNumber: "26",
    title: "Moderne stålcarport med sidebeklædning og fliser",
    suggestedCategory: "Carport",
    description: "Nyopført carport i varmgalvaniseret stål med mørkegrå sidebeklædning, anlagt med fliser og granitskærver i indkørsel.",
    date: "29. maj 2026",
    batch: "Foto-upload 28. september 2026 (Rodmappe)",
    images: [
      {
        fileName: "PXL_20260529_082343854.jpg",
        sitePath: "/_assets/pxl-20260529-082343854.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260529-082343854.jpg",
        title: "Moderne carport i galvaniseret stål med sidebeklædning",
        description: "Galvaniseret carport med tagkonstruktion, koksgrå beklædning og fliser."
      }
    ]
  }
];

export const weTransferBatches = [
  {
    batchId: "batch-1",
    albumNumber: "01",
    title: "Album 1",
    categoryName: "Komposithegn sort pulverlakeret",
    targetPath: "/komposithegn",
    originalFolder: "wetransfer_pxl_20260710_142506610-jpg_2026-07-11_0450",
    albumIds: [7, 8, 9],
    imageCount: 7,
    description: "7 fotos af komposithegn med sort pulverlakerede stolper, profiler og låger.",
    images: [
      {
        fileName: "PXL_20260710_142506610.jpg",
        sitePath: "/_assets/pxl-20260710-142506610.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142506610.jpg",
        title: "Komposithegn i skel"
      },
      {
        fileName: "PXL_20260710_142439967.jpg",
        sitePath: "/_assets/pxl-20260710-142439967.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142439967.jpg",
        title: "Komposithegn mod vej"
      },
      {
        fileName: "PXL_20260710_142248728.jpg",
        sitePath: "/_assets/pxl-20260710-142248728.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260710-142248728.jpg",
        title: "Komposithegn detalje"
      },
      {
        fileName: "PXL_20260626_135051675.MP.jpg",
        sitePath: "/_assets/pxl-20260626-135051675-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-135051675-mp.jpg",
        title: "Komposithegn ved gult murstenshus"
      },
      {
        fileName: "PXL_20260626_134228707.jpg",
        sitePath: "/_assets/pxl-20260626-134228707.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-134228707.jpg",
        title: "Hegn ved indkørsel og hus"
      },
      {
        fileName: "PXL_20260427_130943932.jpg",
        sitePath: "/_assets/pxl-20260427-130943932.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260427-130943932.jpg",
        title: "Hegn og låge ved carport"
      },
      {
        fileName: "PXL_20260427_130837583.jpg",
        sitePath: "/_assets/pxl-20260427-130837583.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260427-130837583.jpg",
        title: "Komplet hegnsløsning ved villa"
      }
    ]
  },
  {
    batchId: "batch-2",
    albumNumber: "02",
    title: "Album 2",
    categoryName: "Rionet hegn",
    targetPath: "/rionet",
    originalFolder: "wetransfer_pxl_20260709_112346689-jpg_2026-07-11_0452",
    albumIds: [10, 11],
    imageCount: 4,
    description: "4 fotos af rionethegn om have og trådhegn ved bolig.",
    images: [
      {
        fileName: "PXL_20260709_112402346.jpg",
        sitePath: "/_assets/pxl-20260709-112402346.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112402346.jpg",
        title: "Rionethegn om køkkenhave"
      },
      {
        fileName: "PXL_20260709_112353116.jpg",
        sitePath: "/_assets/pxl-20260709-112353116.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112353116.jpg",
        title: "Rionethegn vinkel"
      },
      {
        fileName: "PXL_20260709_112346689.jpg",
        sitePath: "/_assets/pxl-20260709-112346689.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260709-112346689.jpg",
        title: "Rionet og højbede"
      },
      {
        fileName: "PXL_20260413_100655471.jpg",
        sitePath: "/_assets/pxl-20260413-100655471.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260413-100655471.jpg",
        title: "Trådhegn og komposithegn ved gult hus"
      }
    ]
  },
  {
    batchId: "batch-3",
    albumNumber: "03",
    title: "Album 3",
    categoryName: "Smedejerns port (2 første) og smedejernslåge/hegn (2 sidste)",
    targetPath: "/porte",
    originalFolder: "wetransfer_pxl_20260705_162325452-jpg_2026-07-11_0455",
    albumIds: [12, 13],
    imageCount: 4,
    description: "4 fotos: 2 første viser galvaniseret svingport i smedejern med automatik; 2 sidste viser sort smedejernslåge/hegn.",
    images: [
      {
        fileName: "PXL_20260705_162325452.jpg",
        sitePath: "/_assets/pxl-20260705-162325452.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260705-162325452.jpg",
        title: "Galvaniseret svingport med automatik"
      },
      {
        fileName: "PXL_20260705_162316724.jpg",
        sitePath: "/_assets/pxl-20260705-162316724.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260705-162316724.jpg",
        title: "Svingport set forfra"
      },
      {
        fileName: "IMG20251015162947.jpg",
        sitePath: "/_assets/img20251015162947.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251015162947.jpg",
        title: "Sort smedejernslåge ved træbeklædning"
      },
      {
        fileName: "IMG20251015162706.jpg",
        sitePath: "/_assets/img20251015162706.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251015162706.jpg",
        title: "Sort smedejernslåge åben"
      }
    ]
  },
  {
    batchId: "batch-4",
    albumNumber: "04",
    title: "Album 4",
    categoryName: "Komposithegn",
    targetPath: "/komposithegn",
    originalFolder: "wetransfer_pxl_20260703_095205669-jpg_2026-07-11_0459",
    albumIds: [14, 15, 16, 17, 18, 19],
    imageCount: 7,
    description: "7 fotos af forskellige typer komposithegn monteret med hegn og låger.",
    images: [
      {
        fileName: "PXL_20260703_095205669.jpg",
        sitePath: "/_assets/pxl-20260703-095205669.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260703-095205669.jpg",
        title: "Sort komposithegn om hjørnegrund"
      },
      {
        fileName: "PXL_20260622_105620052.MP.jpg",
        sitePath: "/_assets/pxl-20260622-105620052-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260622-105620052-mp.jpg",
        title: "Brunt komposithegn med stålstolper"
      },
      {
        fileName: "PXL_20260615_140042784.jpg",
        sitePath: "/_assets/pxl-20260615-140042784.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260615-140042784.jpg",
        title: "Komposithegn med rød bil i indkørsel"
      },
      {
        fileName: "PXL_20260608_112249497.jpg",
        sitePath: "/_assets/pxl-20260608-112249497.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260608-112249497.jpg",
        title: "Komposithegn langs flisegang og teknikskab"
      },
      {
        fileName: "PXL_20260522_165345604.MP.jpg",
        sitePath: "/_assets/pxl-20260522-165345604-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260522-165345604-mp.jpg",
        title: "Komposithegn med to låger"
      },
      {
        fileName: "PXL_20260430_173443839.jpg",
        sitePath: "/_assets/pxl-20260430-173443839.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260430-173443839.jpg",
        title: "Koksgråt komposithegn med låge på fliseareal"
      },
      {
        fileName: "PXL_20260420_113446037.jpg",
        sitePath: "/_assets/pxl-20260420-113446037.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260420-113446037.jpg",
        title: "Kompositlåge og hegn ved indkørsel"
      }
    ]
  },
  {
    batchId: "batch-5",
    albumNumber: "05",
    title: "Album 5",
    categoryName: "Panelhegn og panellåger",
    targetPath: "/panelhegn",
    originalFolder: "wetransfer_pxl_20260727_112148598-mp-jpg_2026-07-11_0502",
    albumIds: [20, 21, 22, 23, 24, 25],
    imageCount: 7,
    description: "7 fotos af galvaniserede og sorte panelhegn samt panellåger.",
    images: [
      {
        fileName: "PXL_20260627_112148598.MP.jpg",
        sitePath: "/_assets/pxl-20260627-112148598-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260627-112148598-mp.jpg",
        title: "Galvaniseret panelhegn omkring sandareal"
      },
      {
        fileName: "PXL_20260626_182849918.MP.jpg",
        sitePath: "/_assets/pxl-20260626-182849918-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260626-182849918-mp.jpg",
        title: "Galvaniseret dobbeltlåge på grusindkørsel"
      },
      {
        fileName: "PXL_20260531_083822023.jpg",
        sitePath: "/_assets/pxl-20260531-083822023.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260531-083822023.jpg",
        title: "Sort panelhegn og låge ved terrasse"
      },
      {
        fileName: "PXL_20260531_083803960.jpg",
        sitePath: "/_assets/pxl-20260531-083803960.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260531-083803960.jpg",
        title: "Sort gitterlåge ved murstensvæg"
      },
      {
        fileName: "PXL_20260508_133014856.jpg",
        sitePath: "/_assets/pxl-20260508-133014856.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260508-133014856.jpg",
        title: "Sort dobbelttrådshegn langs have"
      },
      {
        fileName: "IMG20251224093853.jpg",
        sitePath: "/_assets/img20251224093853.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251224093853.jpg",
        title: "Galvaniseret gitterlåge ved depotrum"
      },
      {
        fileName: "IMG20251223131731.jpg",
        sitePath: "/_assets/img20251223131731.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251223131731.jpg",
        title: "Galvaniseret panelhegn langs grusvej"
      }
    ]
  },
  {
    batchId: "batch-6",
    albumNumber: "06",
    title: "Album 6",
    categoryName: "Kompositdør (6 første) & komposit dobbeltlåge (sidste)",
    targetPath: "/kompositdor",
    originalFolder: "wetransfer_pxl_20260619_125952937-mp-jpg_2026-07-11_0504",
    albumIds: [1, 2, 3, 4, 5, 6],
    imageCount: 7,
    description: "7 fotos: 6 første fotos viser kompositdøre i stålrammer til mure og skure; sidste foto er komposit dobbeltlåge.",
    images: [
      {
        fileName: "IMG20251229122541.jpg",
        sitePath: "/_assets/img20251229122541.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251229122541.jpg",
        title: "Inspektionslem i pudset mur"
      },
      {
        fileName: "IMG20251229122934.jpg",
        sitePath: "/_assets/img20251229122934.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20251229122934.jpg",
        title: "Havedør med stålramme i pudset mur"
      },
      {
        fileName: "IMG20260322162839.jpg",
        sitePath: "/_assets/img20260322162839.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/img20260322162839.jpg",
        title: "Dobbeltport med sorte trælameller"
      },
      {
        fileName: "PXL_20260608_094742985.MP.jpg",
        sitePath: "/_assets/pxl-20260608-094742985-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260608-094742985-mp.jpg",
        title: "Havelåge med sikkerhedspigge"
      },
      {
        fileName: "PXL_20260611_130115349.jpg",
        sitePath: "/_assets/pxl-20260611-130115349.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260611-130115349.jpg",
        title: "Skurdør i galvaniseret stålramme"
      },
      {
        fileName: "PXL_20260615_135924900.jpg",
        sitePath: "/_assets/pxl-20260615-135924900.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260615-135924900.jpg",
        title: "Havelåge mellem murede stolper"
      },
      {
        fileName: "PXL_20260619_125952937.MP.jpg",
        sitePath: "/_assets/pxl-20260619-125952937-mp.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260619-125952937-mp.jpg",
        title: "Bred dobbeltport ved brosten"
      }
    ]
  },
  {
    batchId: "batch-7",
    albumNumber: "07",
    title: "Album 7",
    categoryName: "Carport eller skur",
    targetPath: "/carport",
    originalFolder: "Enkeltupload",
    albumIds: [26],
    imageCount: 1,
    description: "1 foto af nyopført stålcarport med koksgrå sidebeklædning og fliser.",
    images: [
      {
        fileName: "PXL_20260529_082343854.jpg",
        sitePath: "/_assets/pxl-20260529-082343854.jpg",
        url: "https://assets.auxodev.dk/assets/0bc17d51-e4bb-499f-a148-1c26c6fe091c/pxl-20260529-082343854.jpg",
        title: "Stålcarport med sidebeklædning"
      }
    ]
  }
];
